import { ActionType } from 'typesafe-actions';
import BaseReducer, {
	baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import { IShopType } from '../../types/IShopType';
import * as nearestShopActions from './nearestShopActions';

export type NearestShopAction = ActionType<typeof nearestShopActions>;

export interface INearestShopStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: IShopType };
	readonly queries: { [queryKey: string]: IShopType[] };
}

export function nearestShopReducer(
	state = baseInitialState as INearestShopStateType,
	action: NearestShopAction,
) {
	const Reducer = new BaseReducer('nearestShopReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			default:
				return innerState;
		}
	});
}
